import { render, staticRenderFns } from "./Ospendiente.vue?vue&type=template&id=f6a92972&scoped=true"
import script from "./Ospendiente.vue?vue&type=script&lang=js"
export * from "./Ospendiente.vue?vue&type=script&lang=js"
import style0 from "./Ospendiente.vue?vue&type=style&index=0&id=f6a92972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a92972",
  null
  
)

export default component.exports